"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LatestExperimentEntry = _interopRequireDefault(require("./LatestExperimentEntry"));
var _experimentsPropTypes = require("./experimentsPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function LatestExperimentsList(_ref) {
  var experiments = _ref.experiments,
    host = _ref.host;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    style: {
      listStyle: "none",
      marginLeft: "offset"
    }
  }, Array.isArray(experiments) && experiments.map(function (experiment, idx) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: idx
    }, /*#__PURE__*/_react["default"].createElement(_LatestExperimentEntry["default"], _extends({
      host: host
    }, experiment)));
  }));
}
LatestExperimentsList.propTypes = {
  experiments: _propTypes["default"].arrayOf(_propTypes["default"].shape(_experimentsPropTypes.experimentPropTypes)).isRequired,
  host: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = LatestExperimentsList;